import { render, staticRenderFns } from "./RB_origingroup_master.vue?vue&type=template&id=6edcca4a"
import script from "./RB_origingroup_master.vue?vue&type=script&lang=js"
export * from "./RB_origingroup_master.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports